// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__RIo9B","empty":"ModalGraph_empty__hpKz8"};